import { render, staticRenderFns } from "./TwitterIcon.vue?vue&type=template&id=58dadc16&scoped=true"
import script from "./TwitterIcon.vue?vue&type=script&lang=js"
export * from "./TwitterIcon.vue?vue&type=script&lang=js"
import style0 from "./TwitterIcon.vue?vue&type=style&index=0&id=58dadc16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dadc16",
  null
  
)

export default component.exports